import { render, staticRenderFns } from "./TeacherEduRegister.vue?vue&type=template&id=652c1762&scoped=true&"
import script from "./TeacherEduRegister.vue?vue&type=script&lang=js&"
export * from "./TeacherEduRegister.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEduRegister.vue?vue&type=style&index=0&id=652c1762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c1762",
  null
  
)

export default component.exports